import React from "react";
import { ListOrdered } from "lucide-react";
import AdminCrudPage from "./AdminCrudPage";
import { apiGetList, apiPost, apiPut } from "./adminApi";

const fields = [
  { name: "levelName", label: "Education Level", type: "text", required: true, placeholder: "e.g. Bachelor's Degree", fullWidth: true },
];

export default function EducationLevelsPage() {
  return (
    <AdminCrudPage
      title="Education Levels"
      subtitle="Levels of study (e.g. Diploma, Bachelor, Masters, PhD)"
      icon={ListOrdered}
      entityName="education level"
      queryKey="adminEducationLevels"
      fetchAll={() => apiGetList("hec/educationLevel/getAllEducationLevels")}
      createItem={(values) => apiPost("hec/educationLevel/saveEducationLevel", values)}
      updateItem={(id, values) => apiPut("hec/educationLevel/updateEducationLevel", { id, ...values })}
      searchKeys={["levelName"]}
      columns={[
        { key: "levelName", label: "Education Level", render: (r) => <span className="font-semibold text-gray-900">{r.levelName}</span> },
      ]}
      fields={fields}
    />
  );
}
